import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import FinancialDashboard from "./FinancialDashboard";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";
function CompetitiveAnalysis({ subcategoryToken }) {

  return (
    <DashboardLayout>
      <MDBox
             sx={{
               display: {
                 xs: "block",
                 sm: "block",
                 md: "none",
               },
             }}
           >
             <AppHeader />
           </MDBox>
      <FinancialDashboard subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}
export default CompetitiveAnalysis;
